import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../Utils/auth"; // or directly use localStorage

const ProtectedRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
